import { render, staticRenderFns } from "./resource_parent_link.vue.js?vue&type=template&id=9174c600!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./resource_parent_link.vue?vue&type=template&id=9174c600"
import script from "./resource_parent_link.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./resource_parent_link.vue?vue&type=script&lang=js"
export * from "./resource_parent_link.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./resource_parent_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports